let ROOT_URL = "";
let IMAGE_URL = "";
let WEB_URL = "";

if (process.env.REACT_APP_SERVER?.trim() == "production") {
  ROOT_URL = "https://api.tcgdob.com/api/v1";
  WEB_URL = "https://tcgdob.com";
} else if (process.env.REACT_APP_SERVER?.trim() == "staging") {
  ROOT_URL = "https://betaapi.tcgdob.com/api/v1";
  WEB_URL = "https://beta.tcgdob.com";
} else {
  ROOT_URL = "http://localhost:9002/api/v1";
  WEB_URL = "http://localhost:3000";
}

ROOT_URL = "https://betaapi.tcgdob.com/api/v1";
WEB_URL = "https://beta.tcgdob.com";

export { IMAGE_URL, WEB_URL };
export default ROOT_URL;
